module.exports = __webpack_public_path__ + "img/pex_33_halo.66feeb9b.png";